import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import { handleAuth0AuthenticatedCallback } from '../../redux/actions/auth0-callback/auth0CallbackActions';

const Auth0CallbackAuthenticated = () => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(handleAuth0AuthenticatedCallback());
  }, []);

  return null;
};

export default Auth0CallbackAuthenticated;
